import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import Cart from "@system/config/cart";
import System from "../../../helper/system";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
const c = System.getParams();


const ChangeShippingAddressPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ ChangeShippingAddressPopup }, { }, { }] = useDOMAttachToSystemStore();
    const quoteNumber = c.quote_number;

    useEffect(() => {
        if (ChangeShippingAddressPopup) {
            SetStatus(true)
        }
    }, [ChangeShippingAddressPopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const returnToCart = () => {
        let url = Cart.getCartPageRouteURL() + "?ShippingAddressPopup=1";
        if (quoteNumber)
            url = `${Cart.getQuoteCartPageRouteURL()}?ShippingAddressPopup=1&quote_number=${quoteNumber}`;

        window.location.href = url;
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header ">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Change Shipping Address</h3>
                        </div>
                        <div className="modal-body pt-0 text-center">
                            <p className='mb-4'>Items in your cart need to be validated with any address update.<br />
                                You’ll be taken back to your Cart to Add or Change a Shipping Address.</p>
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                onClick={() => {
                                    onHide()
                                }}>cancel</button>
                            <button type="button" className="bs5 btn btn-primary w145" data-toggle="modal" data-target="#shiptoaddress"
                                onClick={() => { returnToCart() }}>continue</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default ChangeShippingAddressPopup;